import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { whatsappLink, unsplashSrc, unsplashSrcset } from "../lib/api";

export const ProjectCard = ({ project, index = 0 }) => (
    <Reveal delay={(index % 3) * 0.1}>
        <div data-testid={`project-card-${project.slug}`} className="group">
            <Link to={`/opportunities/${project.slug}`} className="block" data-testid={`project-view-${project.slug}`}>
                <div className="img-frame aspect-[4/3] bg-secondary">
                    <img
                        src={unsplashSrc(project.hero_image, 960)}
                        srcSet={unsplashSrcset(project.hero_image)}
                        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        alt={project.name}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
                <div className="mt-6 flex items-start justify-between gap-4">
                    <div>
                        <p className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#8a6a1c]">
                            {project.category} &bull; {project.market}
                        </p>
                        <h3 className="mt-2 font-serif text-2xl font-medium leading-tight tracking-tight text-ink transition-colors duration-300 group-hover:text-ink/70">
                            {project.name}
                        </h3>
                        <p className="mt-1 text-sm font-light text-ink/60">
                            {project.developer} &bull; {project.location}
                        </p>
                    </div>
                    <span className="mt-2 flex h-9 w-9 shrink-0 items-center justify-center border border-ink/15 text-ink transition-all duration-500 group-hover:border-gold group-hover:bg-gold group-hover:text-ink">
                        <ArrowUpRight className="h-4 w-4" />
                    </span>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-ink/10 pt-4 text-[12px] font-light text-ink/60">
                    <span>{project.property_type}</span>
                    <span className="text-right">{project.configuration}</span>
                    <span className="font-normal text-ink/80">{project.starting_price}</span>
                    <span className="text-right">{project.status || project.possession}</span>
                </div>
            </Link>
            <div className="mt-4 flex items-center gap-7 text-[11px] font-medium uppercase tracking-[0.2em]">
                <Link
                    to={`/opportunities/${project.slug}`}
                    data-testid={`project-view-link-${project.slug}`}
                    className="link-underline text-ink"
                >
                    View Project
                </Link>
                <a
                    href={whatsappLink(`Hi LUXATI, I'm interested in ${project.name}. Please share the current details and availability.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`project-enquire-${project.slug}`}
                    className="link-underline text-[#8a6a1c]"
                >
                    Enquire With LUXATI
                </a>
            </div>
        </div>
    </Reveal>
);
